import { render, staticRenderFns } from "./BpImportDialog.vue?vue&type=template&id=86a5876c&scoped=true"
import script from "./BpImportDialog.vue?vue&type=script&lang=js"
export * from "./BpImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a5876c",
  null
  
)

export default component.exports